import { styled } from "styled-components";

import { UIModal } from "uikit";

export const StyledUICheckoutModal = styled(UIModal)`
  width: 630px !important;
`;

export const CheckoutModalContent = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  min-height: 200px;
`;
